

module.exports = __webpack_require__.stylable.create(
    "Header2154418173",
    {"classes":{"root":"Header2154418173__root","wrapper":"Header2154418173__wrapper","suffix":"Header2154418173__suffix","titleWrapper":"Header2154418173__titleWrapper"},"vars":{},"stVars":{},"keyframes":{}},
    ".Header2154418173__wrapper{display:flex;align-items:center;justify-content:space-between;padding:27px 30px 26px}.Header2154418173__suffix{height:0;display:flex;align-items:center}.Header2154418173__titleWrapper{min-width:0}",
    1,
    "Header2154418173",
    __webpack_require__.stylable.$
);
